export const RESOLVED_STATUSES = [
  "Resolved",
  "Auto Resolved",
  "Force Resolved",
];

export const tooltipLabels = {
  severity: {
    critical: "Highest severity - needs immediate action",
    "high severity": "High severity - needs immediate troubleshooting",
    warning: "Issue detected - monitor closely",
  },
};

export const csvColumns = [
  {
    key: "deviceID",
    dataIndex: "deviceID",
    headerLabel: "IMEI",
  },
  {
    key: "vehicleSubType",
    dataIndex: "vehicleSubType",
    headerLabel: "Bus Type",
  },
  {
    key: "licensePlateNo",
    dataIndex: "licensePlateNo",
    headerLabel: "Bus Number",
  },
  {
    key: "customerDBTimeInsert",
    dataIndex: "customerDBTimeInsert",
    headerLabel: "Fault Triggered Time",
  },
  {
    key: "originDepo",
    dataIndex: "originDepo",
    headerLabel: "Depot",
  },
  {
    key: "originCity",
    dataIndex: "originCity",
    headerLabel: "City",
  },
  {
    key: "originState",
    dataIndex: "originState",
    headerLabel: "State",
  },
  {
    key: "originCountry",
    dataIndex: "originCountry",
    headerLabel: "Country",
  },
  {
    key: "vin",
    dataIndex: "vin",
    headerLabel: "Chassis Number",
  },
  {
    key: "incidentID",
    dataIndex: "incidentID",
    headerLabel: "Incident ID",
  },
  {
    key: "incidentErrorCode",
    dataIndex: "incidentErrorCode",
    headerLabel: "Fault Code",
  },
  {
    key: "severity",
    dataIndex: "severity",
    headerLabel: "Severity",
  },
  {
    key: "severityLevel",
    dataIndex: "severityLevel",
    headerLabel: "Fault Level",
  },
  {
    key: "incidentErrorName",
    dataIndex: "incidentErrorName",
    headerLabel: "Fault Description",
  },
  {
    key: "bmsAlertStatus",
    dataIndex: "bmsAlertStatus",
    headerLabel: "Fault Status",
  },
  {
    key: "entityAffected",
    dataIndex: "entityAffected",
    headerLabel: "Entity Affected",
  },
  {
    key: "entityAffectedID",
    dataIndex: "entityAffectedID",
    headerLabel: "Entity Affected ID",
  },
  {
    key: "entityAffectedDisplayID",
    dataIndex: "entityAffectedDisplayID",
    headerLabel: "Entity Affected Display ID",
  },
  {
    key: "category",
    dataIndex: "category",
    headerLabel: "Category",
  },
  {
    key: "orgErrorCode",
    dataIndex: "orgErrorCode",
    headerLabel: "Organization Error Code",
  },
  {
    key: "overdueSince",
    dataIndex: "overdueSince",
    headerLabel: "Overdue Since",
  },
];

export const csvColumnsForResolved = [
  ...csvColumns,
  {
    key: "resolveCustomerDBTime",
    dataIndex: "resolveCustomerDBTime",
    headerLabel: "Resolved Time",
  },
  {
    key: "resolutionTime",
    dataIndex: "resolutionTime",
    headerLabel: "Resolved Duration (Minutes)",
  },
];
